import FederalLogo from "../../assets/images/FEDERAL.png";
import TerengganuLogo from "../../assets/images/TERENGGANU.png";
import PerlisLogo from "../../assets/images/PERLIS.png";
import SelangorLogo from "../../assets/images/SELANGOR.png";
import N9Logo from "../../assets/images/NEGERI SEMBILAN.png";
import KelantanLogo from "../../assets/images/KELANTAN.png";
import PerakLogo from "../../assets/images/PERAK.png";
import KedahLogo from "../../assets/images/KEDAH.png";
import PahangLogo from "../../assets/images/PAHANG.png";
import JohorLogo from "../../assets/images/JOHOR.png";
import SabahLogo from "../../assets/images/SABAH.png";
import MelakaLogo from "../../assets/images/MELAKA.png";
import PenangLogo from "../../assets/images/PULAU PINANG.png";
import SarawakLogo from "../../assets/images/SARAWAK.png";

export const stateImages = [
  FederalLogo, //0
  TerengganuLogo, //1
  PerlisLogo, //2
  SelangorLogo, //3
  N9Logo, //4
  KelantanLogo, //5
  PerakLogo, //6
  KedahLogo, //7
  PahangLogo, //8
  JohorLogo, //9
  SabahLogo, //0
  MelakaLogo, //0
  PenangLogo, //0
  SarawakLogo, //0
];
